/**
 * Clean up AI response formatting by removing prefixes, source refs, and markdown.
 */
export const cleanAIResponse = (response: string): string => {
    return response
        // Remove "Home Visitor:" prefix and similar prefixes
        .replace(/^(Home Visitor|Assistant|AI|Bot):\s*/i, '')
        // Remove source references like 【4:11†source】
        .replace(/【[^】]*】/g, '')
        // Remove markdown headers (### ## #)
        .replace(/^#{1,6}\s+/gm, '')
        // Remove bold markdown (**text**)
        .replace(/\*\*(.*?)\*\*/g, '$1')
        // Remove italic markdown (*text*)
        .replace(/\*(.*?)\*/g, '$1')
        // Remove extra whitespace and clean up line breaks
        .replace(/\n\s*\n\s*\n/g, '\n\n')
        // Trim whitespace
        .trim();
};
